__turbopack_context__.v({
  "BannerImage__container": "BannerWithImage-module-scss-module__uLndeW__BannerImage__container",
  "BannerImage__cta": "BannerWithImage-module-scss-module__uLndeW__BannerImage__cta",
  "BannerImage__duration": "BannerWithImage-module-scss-module__uLndeW__BannerImage__duration",
  "BannerImage__durationLabel": "BannerWithImage-module-scss-module__uLndeW__BannerImage__durationLabel",
  "BannerImage__image": "BannerWithImage-module-scss-module__uLndeW__BannerImage__image",
  "BannerImage__leftContainer": "BannerWithImage-module-scss-module__uLndeW__BannerImage__leftContainer",
  "BannerImage__subtitle": "BannerWithImage-module-scss-module__uLndeW__BannerImage__subtitle",
  "BannerImage__title": "BannerWithImage-module-scss-module__uLndeW__BannerImage__title",
  "BannerWithImageNew_CTAStyle": "BannerWithImage-module-scss-module__uLndeW__BannerWithImageNew_CTAStyle",
  "img": "BannerWithImage-module-scss-module__uLndeW__img",
  "noteText": "BannerWithImage-module-scss-module__uLndeW__noteText",
  "sponsor": "BannerWithImage-module-scss-module__uLndeW__sponsor",
});
